module.exports = __webpack_public_path__ + "assets/img/mySwiper-header1.e79c80a9.png";